export const getIsRedesignEnabled = () => !!window?.abTestChoices?.elkProfileEnabled;
export const getIsSettingsRedesignEnabled = () =>
  !!window?.abTestChoices?.elkProfileSettingsEnabled;
